//手机号校验
import { ElMessage, ElMessageBox } from 'element-plus'
import ajax from './axios'

const commons = {
    picAdminBaseUrl: '/admin_api/file/download/',
    picUserBaseUrl: '/user_api/file/download/',

} as any;
commons.phoneRules = (phone)=> {
    const rules = /1[0-9]\d{9}$/;
    return phone && phone.length >= 11 && rules.test(phone);
};

//删除提示
commons.delTIP = (params,successFun,errorFun)=> {
    ElMessageBox.confirm(params.title ||'确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(() => {
        if(!params.url) {
            successFun && successFun();
            return;
        }
        ajax({
            url:  params.url,
            data:  params.data,
            method:  params.method || 'DELETE'
        }).then((res:any) => {
            if (res.status === 0) {
                successFun && successFun();
                ElMessage({
                    message: params.successMessage || '删除成功',
                    type: 'success'
                });
            } else {
                errorFun && errorFun(res);
                ElMessage({
                    message: res.message || '删除失败',
                    type: 'error'
                });
            }
        })
    }).catch(() => {
        errorFun && errorFun();
    })
};

// 现在时间 例：2020-02-01
commons.nowTime =  (num) =>{
    num = num || 0;
    let presentDate= new Date();
    if(num) {
        presentDate.setMonth(presentDate.getMonth() + num);
    }
    return `${presentDate.getFullYear()}-${(presentDate.getMonth() + 1 ) < 10 ? ('0' + (presentDate.getMonth() + 1 )) : (presentDate.getMonth() + 1 )}-${presentDate.getDate() < 10 ? '0' + presentDate.getDate() :presentDate.getDate()}`
};

//将美国时间转化为中国时间
commons.changeChinaTime = (time)=> {
    if(time) {

        let d = new Date(time);
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let date = d.getDate()  < 10 ? ("0" + d.getDate()) : d.getDate() ;
        let hours = d.getHours()  < 10 ? ("0" + d.getHours() ) : d.getHours() ;
        let minutes = d.getMinutes()  < 10 ? ("0" + d.getMinutes() ) : d.getMinutes() ;
        let seconds = d.getSeconds()  < 10 ? ("0" + d.getSeconds() ) : d.getSeconds();
        let times = d.getFullYear() + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds;

        return times;
    }

};


//localhost存储信息
commons.writeLocalStorage = (key,value) =>{
    if (value)
        value = JSON.stringify(value);
    localStorage.setItem(key,value);
};

//读取存取信息
commons.readLocalStorage = (key)=> {

    var value = localStorage.getItem(key);
    if (value && value != "undefined" && value != "null")
        return JSON.parse(value);
    return null;
};
//移除存储信息
commons.removeLocalStorage = (key) =>{
    localStorage.removeItem(key);
};
//清除存储信息
commons.clearLocalStorage = ()=> {
    localStorage.clear();
};

export default commons
